import { createStore, createEvent, createEffect, combine } from 'effector';
import request from '@helpers/request';
import api from '@constants/endpoints';
import createPreloadersStore from './preloaders';
import IPlatform from '@interfaces/IPlatforms';
import { get } from 'lodash';
import { AxiosResponse } from 'axios';

export const reset = createEvent('Platforms store reset');

export const getList = createEffect({
  name: 'getList',
  async handler() {
    const response = await request(api.dictionary.getList, {});

    return response;
  },
});

const preloaders = createPreloadersStore([getList]);

const mapList = (list: AxiosResponse<any>, base: boolean) => {
  const all = get(list, ['data'], []);
  const filtered = all.filter((item: IPlatform) =>
    base ? item.code !== 'OTHER' : item.code === 'OTHER',
  );
  const mapped: any = {};

  filtered.forEach((item: IPlatform) => (mapped[item.description as string] = item.id));
  return mapped;
};

const basePlatforms = createStore<IPlatform[]>([])
  .on(getList.done, (_state, { result }) => {
    return mapList(result, true);
  })
  .reset(reset);

const otherPlatforms = createStore<IPlatform[]>([])
  .on(getList.done, (_state, { result }) => {
    return mapList(result, false);
  })
  .reset(reset);

const platforms = combine({ preloaders, basePlatforms, otherPlatforms });

export default platforms;
